import type { FilterSchema } from '@/shared/components/filter/validation'

import {
	isCompetitorFilter,
	isProductFilter,
} from '@/pages/dashboard/lib/filters'
import { useTranslation } from 'react-i18next'

import { useCPIQuery } from '@/entities/bi'

import { Skeleton } from '@/shared/components/ui/skeleton'
import { cn } from '@/shared/lib/utils'
import { formatNumber, NumberFormats } from '@/shared/tools/locale'

import { Widget, WidgetContent, WidgetHeader } from '../../Widget'
import WidgetErrorState from '../../WidgetErrorState'

export default function NumericAverageCPIWidget({
	commonFilters,
	className,
}: {
	className?: string
	commonFilters: FilterSchema[]
}) {
	const { t } = useTranslation()
	const cpiQuery = useCPIQuery({
		product_filters: commonFilters.filter(isProductFilter) || [],
		cd_filters: commonFilters.filter(isCompetitorFilter) || [],
		dimensions: [],
		label: 'NumericAverageCPIWidget',
	})
	const value = cpiQuery.data?.[0]?.cpi
	const isLoading = cpiQuery.isLoading
	const isError = cpiQuery.isError

	return (
		<Widget className={cn('relative truncate', className)}>
			<WidgetHeader
				title={t('widget.average_cpi.title')}
				tooltip={t('widget.average_cpi.tooltip')}
				subtitle={t('widget.average_cpi.description')}
			/>
			<WidgetErrorState isTinted={isError} size='small' />
			<WidgetContent className='truncate'>
				{isLoading && <Loader />}
				{!isLoading && (
					<div className='space-y-1'>
						<p className='truncate text-3xl font-semibold'>
							{formatNumber(value ?? 0, NumberFormats.Fixed)}
						</p>
					</div>
				)}
			</WidgetContent>
		</Widget>
	)
}
const Loader = () => (
	<div className='space-y-1'>
		<Skeleton className='col-span-2 h-4 w-32' />
		<Skeleton className='col-span-2 h-8 w-32' />
	</div>
)
